import React, { memo } from 'react';

import {
  BasePragmaticDGARoulette,
  PragmaticDGAAndarBahar,
  PragmaticDGABlackJack,
  PragmaticDGABoomOrBust,
  PragmaticDGAGame,
  PragmaticDGAMegaRoulette,
  PragmaticDGAMegaWheel,
  PragmaticDGARoulette,
  PragmaticDGASicBo,
  PragmaticDGASweetBonanza,
} from 'components/slots/PragmaticDGA/hooks';

import {
  AndarBahar,
  BlackJack,
  BoomOrBust,
  MegaRoulette,
  MegaWheel,
  Roulette,
  SicBo,
  SweetBonanza,
} from './components';

type AdditionalInfoProps = {
  gameInfo: PragmaticDGAGame;
}

export const AdditionalInfo = memo(({ gameInfo }: AdditionalInfoProps) => {
  switch (gameInfo.tableType) {
    case 'ROULETTE': {
      const { tableSubtype } = gameInfo as BasePragmaticDGARoulette;
      switch (tableSubtype) {
        case 'megaroulette': {
          const { last20Results = [] } = gameInfo as PragmaticDGAMegaRoulette;
          return <MegaRoulette results={last20Results} />
        }
        default: {
          const { last20Results = [] } = gameInfo as PragmaticDGARoulette;
          return <Roulette results={last20Results} />;
        }
      }
    }

    case 'BLACKJACK': {
      const blackJackInfo = gameInfo as PragmaticDGABlackJack;
      return <BlackJack {...blackJackInfo} />;
    }

    case 'SicBO': {
      const { last20Results = [] } = gameInfo as PragmaticDGASicBo;
      return <SicBo results={last20Results} />
    }

    case 'MEGAWHEEL': {
      const { last20Results = [] } = gameInfo as PragmaticDGAMegaWheel;
      return <MegaWheel results={last20Results} />
    }

    case 'ANDARBAHAR': {
      const { gameResult = [] } = gameInfo as PragmaticDGAAndarBahar;
      return <AndarBahar results={gameResult.reverse()} />
    }

    case 'SWEETBONANZA': {
      const { gameResult = [] } = gameInfo as PragmaticDGASweetBonanza;
      return <SweetBonanza results={gameResult} />
    }

    case 'BOOMORBUST': {
      const { gameResult = [] } = gameInfo as PragmaticDGABoomOrBust;
      return <BoomOrBust results={gameResult} />
    }

    default:
      return null;
  }
});
